// The admin catalog of portals Olio knows how to drive — the settings page renders one
// configuration tab per entry, for whichever client the admin is editing.
//
// End-user surfaces do NOT read this. They read GET /portal_connections, which carries each
// portal's `displayName` alongside its readiness (see hooks/usePortalConnections). This page
// can't: connections are derived for the ACTING client and list only portals already
// configured, whereas configuring a portal for the first time is exactly what this page is
// for — so it needs the full catalog for an arbitrary client, which no endpoint serves yet.
//
// Mirrors the api's PortalScript::SOURCE_SYSTEM_LABELS. SAFE TO DELETE once an admin-scoped
// catalog endpoint exists; nothing else in the app duplicates the server's names.
const SOURCE_SYSTEM_LABELS: Record<string, string> = {
  careport: 'Careport',
  // The identifier stays `fauxlio` (it's the source_system value on the wire and the api's
  // PortalScript::SOURCE_SYSTEMS entry); only the display name follows the product's own
  // branding — the mock portal calls itself Faux-Port.
  fauxlio: 'Faux-Port',
};

export const SOURCE_SYSTEMS = Object.keys(SOURCE_SYSTEM_LABELS);

export function sourceSystemLabel(value: string): string {
  return SOURCE_SYSTEM_LABELS[value] ?? value.charAt(0).toUpperCase() + value.slice(1);
}
